<template>
    <v-container
            id="shipment"
            tag="section"
            fluid
    >

        <v-breadcrumbs :items="breadcrumb">
            <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                        :to="item.href"
                        :disabled="item.disabled"
                >
                    {{ item.text.toUpperCase() }}
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>

        <v-card
                :loading="loading ? 'white' : ''"
                max-width="600px"
        >

            <v-card-title class="black white--text">
                <span class="headline">{{ $t('shipment.shipment_informations')}}</span>
                <v-spacer></v-spacer>
            </v-card-title>

            <v-container fluid>
                <p class="ma-0" v-if="shipment && !loading">
                    <strong>{{ $t('shipment.kind') }}</strong>&nbsp;{{ shipment.kind === 'FROM_STORE_TO_CUSTOMER' ?
                    $t('orders.to_buyer') : $t('orders.to_imparfaite')}} <br/>
                    <strong>{{ $t('shipment.status') }}</strong>&nbsp;{{ getStatusLabel(shipment.status) }} <br/>
                    <strong>{{ $t('shipment.carrier') }}</strong>&nbsp;{{ shipment.carrier}} <br/>
                    <strong>{{ $t('shipment.tracking_url') }}</strong>&nbsp;
                    <router-link :to="shipment.tracking_url"
                                 target="_blank">{{
                        shipment.tracking_url}}
                    </router-link>
                    <br/>
                    <strong>{{ $t('shipment.sent_datetime') }}</strong>&nbsp;{{ shipment.sent_datetime | momentDate }}
                </p>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
    export default {
        name: 'Shipment',

        beforeMount() {
            this.load();
        },

        data() {
            return {
                shipment: {},
                loading: false,
                breadcrumb: [
                    {
                        text: this.$i18n.t('global.shipments'),
                        disabled: false,
                        href: '/shipments',
                    }
                ],
            };
        },

        methods: {
            load() {
                if (this.$route.params.id) {
                    this.loading = true;
                    this.$axios.get('shipments/' + this.$route.params.id)
                        .then(response => {
                            this.loading = false;
                            this.shipment = response.data;
                            this.breadcrumb.push({
                                text: this.$i18n.t('shipment.shipment') + ' ' + this.shipment.carrier,
                                disabled: true,
                            });
                        });
                }
            },
            getStatusLabel(status) {
                return this.$i18n.t('shipments.status_labels.' + status.toLowerCase())
            },
        },

        computed: {},
    }
</script>